import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipDropdownComponent } from '../../../../shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeAutocompleteComponent } from '../../../../shared/payee-form-fields/payee-autocomplete/payee-autocomplete.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-role-filter',
  templateUrl: './role-filter.component.html',
  styleUrls: ['./role-filter.component.scss'],
  imports: [
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    PayeeAutocompleteComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeButtonComponent,
  ],
})
export class RoleFilterComponent {
  readonly formControl = new FormControl<{ name: string } | null>(null);
  dropdownOpen = false;

  @Input() value: { name: string } | null = null;
  @Output() valueChange = new EventEmitter<{ name: string } | null>();

  readonly roleOptions: { name: string }[] = [
    { name: 'user' },
    { name: 'attorney' },
    { name: 'admin' },
    { name: 'Super-Admin' },
  ];

  removed(): void {
    this.value = null;
    this.valueChange.emit(this.value);
    this.dropdownOpen = false;
    this.formControl.patchValue(null);
  }

  apply(): void {
    this.value = this.formControl.value;
    this.valueChange.emit(this.value);
    this.dropdownOpen = false;
  }

  displayRole(role: { name: string }): string {
    return role?.name || '';
  }
}
